export default {
  postLogin(email, pass, workspaceId = null) {
    const obj = {
      actionType: appConstants.ActionTypes.POST_LOGIN,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EMAIL_PARAM')] = email;
    obj.postData[Utils.getEndpointParam('PASSWORD_PARAM')] = pass;
    if (workspaceId) {
      obj.postData[Utils.getEndpointParam('WORKSPACE_ID_PARAM')] = workspaceId.trim();
    }
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
